import { translateInline } from './translateInline';

export const siteDescription = translateInline({
	en: 'The official source of information for doing business in the Netherlands, made available by the Dutch government.',
	nl: 'Informatie en advies van de overheid voor ondernemers door KVK, Belastingdienst, RVO, CBS, UWV en andere overheidsorganisaties.',
});

export const siteTitle = translateInline({
	en: 'Business.gov.nl',
	nl: 'Ondernemersplein',
});
